/**
 * BentoVox cart add-flow
 * GET → Pick DAW → (Waves/Stock if needed) → Claim gift → Bag + discount progress → Checkout
 *
 * Discount (Vocal Presets collection only):
 * Discount (Vocal Presets only):
 *   1 → full · 2 → 10% · 3 → 20% · 4+ → 30%
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-bcaf]');
  if (!root) return;
  // Prevent double-init (theme HMR / duplicate script tags bind listeners twice).
  if (root.getAttribute('data-bcaf-ready') === '1') return;
  root.setAttribute('data-bcaf-ready', '1');

  // Keep drawer as a direct <body> child so page-blur
  // (body > *:not([data-bcaf])) never wraps/filters the checkout bar.
  // Shopify apps / section groups can otherwise leave frost over Secure Checkout.
  function ensureBodyMount() {
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
  }
  ensureBodyMount();

  var steplabel = root.querySelector('[data-bcaf-steplabel]');
  var steptitle = root.querySelector('[data-bcaf-steptitle]');
  var stepsub = root.querySelector('[data-bcaf-stepsub]');
  var progressSegs = root.querySelectorAll('.cart-drawer__progress-seg');
  var countEl = root.querySelector('[data-bcaf-count]');
  var giftBox = root.querySelector('[data-bcaf-gift]');
  var giftStatus = root.querySelector('[data-bcaf-gift-status]');
  var giftClaim = root.querySelector('[data-bcaf-gift-claim]');
  var giftContinue = root.querySelector('[data-bcaf-gift-continue]');
  var giftArt = root.querySelector('[data-bcaf-gift-art]');
  var giftCheck = root.querySelector('.cart-gift-step__check');
  var dawList = root.querySelector('[data-bcaf-daw-grid]');
  var headEl = root.querySelector('[data-bcaf-head]');
  var footerEl = root.querySelector('[data-bcaf-footer]');
  var bagItemsEl = root.querySelector('[data-bcaf-bag-items]');
  var bagCountEl = root.querySelector('[data-bcaf-bag-count]');
  var upsellListEl = root.querySelector('[data-bcaf-upsell-list]');
  var dealFill = root.querySelector('[data-bcaf-deal-fill]');
  var dealFillSoft = root.querySelector('[data-bcaf-deal-fill-soft]');
  var dealTitle = root.querySelector('[data-bcaf-deal-title]');
  var dealSub = root.querySelector('[data-bcaf-deal-sub]');
  var dealEyebrow = root.querySelector('[data-bcaf-deal-eyebrow]');
  var dealPill = root.querySelector('[data-bcaf-deal-pill]');
  var dealCheck = root.querySelector('[data-bcaf-deal-check]');
  var dealDot = root.querySelector('[data-bcaf-deal-dot]');
  var footerTotal = root.querySelector('[data-bcaf-footer-total]');
  var footerWas = root.querySelector('[data-bcaf-footer-was]');
  var footerNudge = root.querySelector('[data-bcaf-footer-nudge]');
  var footerNudgeLabel = root.querySelector('[data-bcaf-footer-nudge-label]');
  var checkoutBtn = root.querySelector('[data-bcaf-checkout]');
  var upsellHint = root.querySelector('[data-bcaf-upsell-hint]');
  var dealRoot = root.querySelector('[data-bcaf-deal]');
  var emptyEl = root.querySelector('[data-bcaf-empty]');
  var mobileEl = root.querySelector('[data-bcaf-mobile]');
  var emptyBrowse = root.querySelector('[data-bcaf-empty-browse]');

  var DAW_LABELS = {
    'fl-studio': 'FL Studio',
    ableton: 'Ableton Live',
    'logic-pro': 'Logic Pro',
    'pro-tools': 'Pro Tools',
    bandlab: 'BandLab',
    'studio-one': 'Fender Studio Pro',
  };

  /* Shorter labels for the 2-col bag DAW grid (matches TVB density). */
  var DAW_LABELS_SHORT = {
    'fl-studio': 'FL Studio',
    ableton: 'Ableton',
    'logic-pro': 'Logic',
    'pro-tools': 'Pro Tools',
    bandlab: 'BandLab',
    'studio-one': 'Fender',
  };

  // Match product option values (store uses Ableton Live / Fender Studio Pro, etc.)
  var DAW_MATCH = {
    'fl-studio': ['fl studio'],
    ableton: ['ableton live', 'ableton'],
    'logic-pro': ['logic pro', 'logic'],
    'pro-tools': ['pro tools'],
    bandlab: ['bandlab'],
    'studio-one': ['fender studio pro', 'studio one', 'studio pro'],
  };

  var PLUGIN_LABELS = {
    waves: 'Waves',
    stock: 'Stock',
  };

  function giftConfig() {
    return {
      handle: root.getAttribute('data-bcaf-gift-handle') || 'the-free-recording-template',
      title: root.getAttribute('data-bcaf-gift-title') || 'The Free Recording Template',
      image: root.getAttribute('data-bcaf-gift-image') || '',
      variantId: Number(root.getAttribute('data-bcaf-gift-variant') || 0) || 0,
      productId: root.getAttribute('data-bcaf-gift-product') || '15849776021790',
      compare: Number(root.getAttribute('data-bcaf-gift-compare') || 5999) || 5999,
    };
  }

  function isGiftLine(item) {
    if (!item) return false;
    var g = giftConfig();
    if (g.variantId && String(item.variant_id) === String(g.variantId)) return true;
    if (g.productId && String(item.product_id) === String(g.productId)) return true;
    if (g.handle && item.handle === g.handle) return true;
    var props = item.properties || {};
    if (props._free_gift || props._gift_claimed) return true;
    return false;
  }

  function giftAlreadyInCart(cart) {
    return (cart.items || []).some(isGiftLine);
  }

  var state = {
    open: false,
    handle: '',
    product: null,
    daw: '',
    plugin: '',
    step: 1,
    hasPluginChoice: false,
    reservedSec: 9 * 60 + 59,
    timerId: null,
    busy: false,
    giftClaimed: false,
    catalog: null,
    cart: null,
    dealDismissed: false,
    fallbackVariantId: null,
    lastDealTier: null,
    lastDealQty: null,
  };

  var surgeTimer = null;

  var COPY = {
    daw: {
      title: 'Pick your DAW',
      sub: 'Your presets install straight into the DAW you produce in.',
    },
    plugin: {
      title: 'Pick your DAW',
      sub: 'Pick the version that matches your installed plugins.',
    },
    gift: {
      title: 'Claim your secret gift',
      sub: 'A free bonus is waiting — tap to reveal it.',
    },
    bag: {
      title: 'Your bag',
      sub: 'Review your presets, unlock bundle savings, then checkout.',
    },
  };

  function loadCatalog() {
    if (state.catalog) return state.catalog;
    var el = document.getElementById('bcaf-vocal-presets-catalog');
    if (!el) {
      state.catalog = { products: [], discount: { tiers: [] } };
      return state.catalog;
    }
    try {
      state.catalog = JSON.parse(el.textContent || '{}');
    } catch (e) {
      state.catalog = { products: [], discount: { tiers: [] } };
    }
    if (!state.catalog.products) state.catalog.products = [];
    return state.catalog;
  }

  function vpIdSet() {
    var cat = loadCatalog();
    var set = {};
    (cat.products || []).forEach(function (p) {
      if (p && p.id != null) set[String(p.id)] = true;
    });
    return set;
  }

  function formatMoney(cents, withCurrency) {
    cents = Math.round(Number(cents) || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var fmt =
        (withCurrency && Shopify.money_with_currency_format) ||
        (window.theme && theme.moneyFormat) ||
        Shopify.money_format ||
        '${{amount}}';
      try {
        return Shopify.formatMoney(cents, fmt);
      } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var TIMER_CYCLE_SEC = 9 * 60 + 59; /* 9:59 → 0 → loop */
  var TIMER_DEADLINE_KEY = 'bcaf_reserved_deadline';

  function formatTime(sec) {
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function readDeadline() {
    try {
      var raw = sessionStorage.getItem(TIMER_DEADLINE_KEY);
      var d = raw ? parseInt(raw, 10) : 0;
      return d && !isNaN(d) ? d : 0;
    } catch (err) {
      return 0;
    }
  }

  function writeDeadline(ms) {
    try {
      sessionStorage.setItem(TIMER_DEADLINE_KEY, String(ms));
    } catch (err) {}
  }

  /* Keep a rolling deadline so reopen continues mid-cycle (never resets to full). */
  function syncReservedFromDeadline() {
    var now = Date.now();
    var deadline = readDeadline();
    if (!deadline) {
      deadline = now + TIMER_CYCLE_SEC * 1000;
      writeDeadline(deadline);
    }
    var left = Math.ceil((deadline - now) / 1000);
    if (left <= 0) {
      /* Finished a cycle → roll to next 9:59 window. */
      var overdue = now - deadline;
      var cycles = Math.floor(overdue / (TIMER_CYCLE_SEC * 1000)) + 1;
      deadline = deadline + cycles * TIMER_CYCLE_SEC * 1000;
      writeDeadline(deadline);
      left = Math.ceil((deadline - now) / 1000);
    }
    state.reservedSec = Math.max(0, Math.min(TIMER_CYCLE_SEC, left));
    return state.reservedSec;
  }

  function paintTimer() {
    var t = formatTime(state.reservedSec);
    root.querySelectorAll('[data-bcaf-timer]').forEach(function (el) {
      el.textContent = t;
    });
  }

  function startTimer() {
    syncReservedFromDeadline();
    paintTimer();
    if (state.timerId) return; /* already ticking — don't reset */
    state.timerId = setInterval(function () {
      syncReservedFromDeadline();
      paintTimer();
    }, 1000);
  }

  function stopTimer() {
    /* Clear interval only — deadline stays so the next open continues. */
    if (state.timerId) {
      clearInterval(state.timerId);
      state.timerId = null;
    }
  }

  function guidedStepTotal() {
    return state.hasPluginChoice ? 3 : 2;
  }

  function setStep(n) {
    state.step = n;
    root.setAttribute('data-bcaf-step', String(n));
    root.classList.toggle('is-bag', n === 4);
    if (n !== 4) root.classList.remove('is-empty');

    root.querySelectorAll('[data-bcaf-panel]').forEach(function (panel) {
      var id = parseInt(panel.getAttribute('data-bcaf-panel'), 10);
      if (id === n) {
        panel.removeAttribute('hidden');
        panel.classList.remove('cart-step-anim');
        void panel.offsetWidth;
        panel.classList.add('cart-step-anim');
      } else {
        panel.setAttribute('hidden', '');
        panel.classList.remove('cart-step-anim');
      }
    });

    if (headEl) {
      headEl.removeAttribute('hidden');
      headEl.classList.remove('cart-step-anim--head');
      void headEl.offsetWidth;
      headEl.classList.add('cart-step-anim--head');
    }

    if (footerEl) {
      if (n === 4 && !root.classList.contains('is-empty')) footerEl.removeAttribute('hidden');
      else footerEl.setAttribute('hidden', '');
    }

    if (n === 4) {
      if (steplabel) steplabel.textContent = '';
      if (steptitle) steptitle.textContent = COPY.bag.title;
      if (stepsub) stepsub.textContent = COPY.bag.sub;
      progressSegs.forEach(function (seg) {
        seg.classList.add('is-on');
        seg.classList.add('is-done');
      });
      bindBagBodyScroll();
      refreshBag();
      return;
    }

    var total = guidedStepTotal();
    var displayIndex = n;
    if (!state.hasPluginChoice && n === 3) displayIndex = 2;

    var copy = COPY.daw;
    if (n === 2) copy = COPY.plugin;
    if (n === 3) copy = COPY.gift;

    if (steplabel) steplabel.textContent = 'STEP ' + displayIndex + ' OF ' + total;
    if (steptitle) steptitle.textContent = copy.title;
    if (stepsub) stepsub.textContent = copy.sub;

    progressSegs.forEach(function (seg, i) {
      if (i < displayIndex) {
        seg.classList.add('is-on');
        seg.classList.add('is-done');
      } else {
        seg.classList.remove('is-on');
        seg.classList.remove('is-done');
      }
    });
  }

  function productHasPluginChoice(product) {
    if (!product || !product.options) return false;
    return product.options.some(function (opt) {
      var name = (opt.name || '').toLowerCase();
      var vals = (opt.values || []).map(function (v) {
        return String(v).toLowerCase();
      });
      if (name.indexOf('version') !== -1 || name.indexOf('plugin') !== -1) {
        return vals.some(function (v) {
          return v.indexOf('waves') !== -1 || v.indexOf('stock') !== -1;
        });
      }
      return vals.some(function (v) {
        return v === 'waves' || v === 'stock';
      });
    });
  }

  function variantHay(v) {
    var parts = [
      v.title || '',
      v.option1 || '',
      v.option2 || '',
      v.option3 || '',
      (v.options || []).join(' '),
    ];
    return parts.join(' ').toLowerCase();
  }

  function dawMatchesVariant(dawKey, v) {
    var needles = DAW_MATCH[dawKey] || [String(DAW_LABELS[dawKey] || dawKey).toLowerCase()];
    var hay = variantHay(v);
    if (!hay.trim()) return false;
    return needles.some(function (n) {
      return n && hay.indexOf(n) !== -1;
    });
  }

  function pluginMatchesVariant(pluginKey, v) {
    if (!pluginKey) return true;
    var label = String(PLUGIN_LABELS[pluginKey] || pluginKey).toLowerCase();
    if (!label) return true;
    var hay = variantHay(v);
    return hay.indexOf(label) !== -1;
  }

  function isVariantAvailable(v) {
    return !!(v && v.available !== false);
  }

  function variantsForDaw(product, dawKey) {
    if (!product || !product.variants) return [];
    return product.variants.filter(function (v) {
      return dawMatchesVariant(dawKey, v) && isVariantAvailable(v);
    });
  }

  function availableDawKeys(product) {
    var keys = Object.keys(DAW_LABELS);
    if (!product || !product.variants) return [];
    return keys.filter(function (key) {
      return variantsForDaw(product, key).length > 0;
    });
  }

  function pluginsForDaw(product, dawKey) {
    var list = variantsForDaw(product, dawKey);
    var hasWaves = list.some(function (v) {
      return pluginMatchesVariant('waves', v);
    });
    var hasStock = list.some(function (v) {
      return pluginMatchesVariant('stock', v);
    });
    var out = [];
    if (hasWaves) out.push('waves');
    if (hasStock) out.push('stock');
    return out;
  }

  function syncDawButtons() {
    if (!dawList) return;
    var keys = availableDawKeys(state.product);
    var visible = 0;
    dawList.querySelectorAll('[data-bcaf-daw]').forEach(function (btn) {
      var key = btn.getAttribute('data-bcaf-daw');
      var show = keys.indexOf(key) !== -1;
      btn.hidden = !show;
      if (show) visible += 1;
    });
    var soon = dawList.querySelector('[data-bcaf-daw-soon]');
    if (soon) soon.hidden = visible > 0;
  }

  function syncPluginButtons() {
    var plugins = pluginsForDaw(state.product, state.daw);
    var visible = 0;
    root.querySelectorAll('[data-bcaf-plugin-wrap]').forEach(function (wrap) {
      var key = wrap.getAttribute('data-bcaf-plugin-wrap');
      var show = plugins.indexOf(key) !== -1;
      wrap.hidden = !show;
      if (show) visible += 1;
    });
    // Fallback if wraps aren't present (older markup)
    root.querySelectorAll('[data-bcaf-plugin]').forEach(function (btn) {
      if (btn.closest('[data-bcaf-plugin-wrap]')) return;
      var key = btn.getAttribute('data-bcaf-plugin');
      var show = plugins.indexOf(key) !== -1;
      btn.hidden = !show;
      var hint = btn.nextElementSibling;
      if (hint && hint.tagName === 'P') hint.hidden = !show;
      if (show) visible += 1;
    });
    var soon = root.querySelector('[data-bcaf-plugin-soon]');
    if (soon) soon.hidden = visible > 0;
  }

  function findVariantIdFor(product, dawKey, pluginKey, fallbackId) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (!dawKey) return null;

    var list = variantsForDaw(product, dawKey);
    if (!list.length) return fallbackId ? Number(fallbackId) : null;

    if (pluginKey) {
      var withPlugin = list.filter(function (v) {
        return pluginMatchesVariant(pluginKey, v);
      });
      if (withPlugin.length) list = withPlugin;
      else if (list.length === 1) {
        /* keep single DAW variant */
      } else {
        var stockOnly = list.filter(function (v) {
          return pluginMatchesVariant('stock', v);
        });
        if (stockOnly.length) list = stockOnly;
      }
    }

    var match = list.find(isVariantAvailable) || list[0];
    if (match && match.id) return Number(match.id);
    if (fallbackId) return Number(fallbackId);
    return null;
  }

  function findVariantId() {
    var id = findVariantIdFor(
      state.product,
      state.daw,
      state.hasPluginChoice ? state.plugin : state.plugin,
      state.fallbackVariantId
    );
    return id;
  }

  function loadProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('product ' + handle);
      return r.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function propVal(item, key) {
    var props = item && item.properties ? item.properties : {};
    var v = props[key];
    if (v == null || v === '') v = props[key.toLowerCase()];
    return v != null ? String(v) : '';
  }

  function dawLabelForKey(key) {
    return DAW_LABELS[key] || key || '';
  }

  function pluginLabelForKey(key) {
    return PLUGIN_LABELS[key] || key || '';
  }

  /** Match cart line to product + optional DAW / Version selection. */
  function lineMatchesSelection(item, productId, dawKey, pluginKey) {
    if (!item || String(item.product_id) !== String(productId)) return false;
    if (dawKey) {
      var wantDaw = String(dawLabelForKey(dawKey)).toLowerCase();
      var gotDaw = propVal(item, 'DAW').toLowerCase();
      // Also accept variant title containing the DAW name
      var title = String(item.variant_title || item.title || '').toLowerCase();
      if (gotDaw) {
        if (gotDaw.indexOf(wantDaw) === -1 && wantDaw.indexOf(gotDaw) === -1) return false;
      } else if (title.indexOf(wantDaw) === -1) {
        return false;
      }
    }
    if (pluginKey) {
      var wantPlug = String(pluginLabelForKey(pluginKey)).toLowerCase();
      var gotPlug = propVal(item, 'Version').toLowerCase();
      var title2 = String(item.variant_title || item.title || '').toLowerCase();
      if (gotPlug) {
        if (gotPlug.indexOf(wantPlug) === -1) return false;
      } else if (title2.indexOf(wantPlug) === -1) {
        return false;
      }
    }
    return true;
  }

  function findCartLine(cart, productId, dawKey, pluginKey) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (lineMatchesSelection(items[i], productId, dawKey, pluginKey)) return items[i];
    }
    return null;
  }

  function productAlreadyInCart(cart, productOrId, handle) {
    var pid =
      productOrId && typeof productOrId === 'object' ? productOrId.id : productOrId;
    var h =
      handle ||
      (productOrId && typeof productOrId === 'object' && productOrId.handle) ||
      '';
    return ((cart && cart.items) || []).some(function (item) {
      if (pid != null && String(item.product_id) === String(pid)) return true;
      if (h && item.handle && String(item.handle) === String(h)) return true;
      return false;
    });
  }

  function variantAlreadyInCart(cart, variantId) {
    if (variantId == null || variantId === '') return false;
    return ((cart && cart.items) || []).some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function hideAllPanels() {
    root.querySelectorAll('[data-bcaf-panel]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsPayload(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    // Dawn cart-drawer is not mounted — only refresh the header bubble.
    return ['cart-icon-bubble'];
  }

  function parseCartJson(r) {
    return r.text().then(function (text) {
      var data = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = { message: text.slice(0, 120) };
        }
      }
      if (!r.ok) {
        var err = data && typeof data === 'object' ? data : {};
        if (!err.description && !err.message) {
          err.description = 'Could not add to cart (HTTP ' + r.status + ')';
        }
        throw err;
      }
      return data;
    });
  }

  function addByVariant(variantId, properties, qty) {
    return addCartItems([
      {
        id: variantId,
        quantity: qty || 1,
        properties: properties || {},
      },
    ]);
  }

  function addCartItems(items) {
    var list = (items || [])
      .map(function (it) {
        return {
          id: Number(it.id),
          quantity: it.quantity || 1,
          properties: it.properties || {},
        };
      })
      .filter(function (it) {
        return it.id && isFinite(it.id);
      });
    if (!list.length) {
      return Promise.reject({ description: 'No matching variant for your DAW selection.' });
    }
    if (state.busy) return Promise.resolve(null);
    var drawer = cartDrawer();
    state.busy = true;
    var body = {
      items: list,
      sections: sectionsPayload(drawer),
      sections_url: window.location.pathname,
    };
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
      .then(parseCartJson)
      .then(function (data) {
        state.busy = false;
        applyCartSections(data);
        return data;
      })
      .catch(function (err) {
        state.busy = false;
        console.error('[bcaf] add failed', err, 'items', list);
        throw err;
      });
  }

  function ensureOpen() {
    state.open = true;
    ensureBodyMount();
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.classList.add('bcaf-lock', 'bcaf-blur');
    // So mobile browser Back closes the drawer instead of leaving the page
    // (and landing on native /cart if that URL is in history).
    try {
      if (!history.state || !history.state.bcaf) {
        history.pushState({ bcaf: 1 }, '', location.href);
      }
    } catch (err) {}
  }

  function showBagAfterAdd() {
    ensureOpen();
    startTimer();
    setStep(4);
    return refreshBag();
  }

  function addSelectedVariantThenBag() {
    if (!state.product) {
      alert('Product options are still loading. Try again in a moment.');
      return Promise.reject(new Error('no product'));
    }
    var id = findVariantId();
    if (!id) {
      console.warn('[bcaf] no variant for', state.daw, state.plugin, state.handle);
      alert('No matching DAW / plugin variant. Pick your DAW again.');
      setStep(1);
      return Promise.reject(new Error('no variant'));
    }

    var productId = state.product.id;
    var gift = giftConfig();

    // Same SKU already in cart → still add gift if claimed & missing, then open bag.
    return fetchCart()
      .then(function (cart) {
        var toAdd = [];
        if (!variantAlreadyInCart(cart, id)) {
          var properties = {};
          if (state.daw) properties.DAW = dawLabelForKey(state.daw);
          if (state.plugin) properties.Version = pluginLabelForKey(state.plugin);
          toAdd.push({ id: id, quantity: 1, properties: properties });
        }
        if (state.giftClaimed && gift.variantId && !giftAlreadyInCart(cart)) {
          toAdd.push({
            id: gift.variantId,
            quantity: 1,
            properties: { _free_gift: gift.title },
          });
        }
        if (!toAdd.length) {
          return showBagAfterAdd();
        }

        return addCartItems(toAdd).then(function (data) {
          if (!data) {
            return fetchCart().then(function (c2) {
              if (
                variantAlreadyInCart(c2, id) ||
                productAlreadyInCart(c2, productId, state.handle) ||
                (state.giftClaimed && giftAlreadyInCart(c2))
              ) {
                return showBagAfterAdd();
              }
              return null;
            });
          }
          return showBagAfterAdd();
        });
      })
      .catch(function (err) {
        return fetchCart()
          .then(function (cart) {
            if (
              variantAlreadyInCart(cart, id) ||
              productAlreadyInCart(cart, productId, state.handle)
            ) {
              return showBagAfterAdd();
            }
            console.error('[bcaf] add failed', err);
            alert((err && err.description) || (err && err.message) || 'Could not add to cart');
            throw err;
          })
          .catch(function (err2) {
            if (err2 === err) throw err;
            console.error('[bcaf] add failed', err);
            alert((err && err.description) || (err && err.message) || 'Could not add to cart');
            throw err;
          });
      });
  }

  function showGiftOrFinish() {
    return fetchCart()
      .then(function (cart) {
        if (giftAlreadyInCart(cart)) {
          state.giftClaimed = true;
          return finishAddFlow();
        }
        setStep(3);
      }, function (err) {
        console.warn('[bcaf] gift check failed', err);
        setStep(3);
      });
  }

  function afterDaw() {
    var plugins = pluginsForDaw(state.product, state.daw);
    var needsPlugin = state.hasPluginChoice && plugins.length > 1;
    if (needsPlugin) {
      syncPluginButtons();
      setStep(2);
      return;
    }
    // Single in-stock version for this DAW (or none tagged) — skip plugin step
    state.plugin = plugins[0] || '';
    showGiftOrFinish();
  }

  function applyCartSections(data) {
    var drawer = cartDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function' || !data || !data.sections) return;
    // Dawn's renderContents always opens the Taste drawer — stub open so bcaf stays the UI.
    var origOpen = drawer.open;
    drawer.open = function () {};
    try {
      drawer.renderContents(data);
    } finally {
      drawer.open = origOpen;
    }
    if (typeof drawer.close === 'function') drawer.close();
    drawer.classList.remove('active');
  }

  function vocalPresetQty(cart) {
    var ids = vpIdSet();
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      // Free gift template never counts toward bundle progress / discount tiers.
      if (isGiftLine(item)) return;
      if (ids[String(item.product_id)]) qty += item.quantity || 0;
    });
    return qty;
  }

  function discountForQty(qty) {
    if (qty >= 4) return 30;
    if (qty >= 3) return 20;
    if (qty >= 2) return 10;
    return 0;
  }

  /* Discount progress hero — copy per Vocal Preset qty.
     Stops on bar: 10%@2 · 20%@3 · 30%@4+
     fill = solid locked progress · fillSoft = tint toward next stop
     FREE GIFT never counts (vocalPresetQty). */
  function dealCopy(qty) {
    if (qty <= 0) {
      return {
        eyebrow: 'BUNDLE & SAVE',
        title: 'Add presets to unlock discounts',
        sub: 'Vocal Presets only<br>1 = 1 Free Gift · 2 = 10% · 3 = 20% · 4+ = 30%',
        pill: '',
        pillGhost: false,
        fill: 0,
        fillSoft: 0,
        locked: false,
        showDot: true,
        tier: 1,
        hint: '+ Add presets → save',
        footerNudge: '',
      };
    }
    // 1 paid — no hard lock yet; soft gradient from 0 → 10% stop
    if (qty === 1) {
      return {
        eyebrow: 'BUNDLE & SAVE',
        title: 'One more to save <em>10%</em> <span class="cart-mobile__hero-emoji">😢</span>',
        sub: 'Add one preset to unlock your first reward.',
        pill: '10% next',
        pillGhost: true,
        fill: 0,
        fillSoft: 33.333,
        locked: false,
        showDot: true,
        tier: 1,
        hint: '+ Add 1 preset → 10% off',
        footerNudge: '1 more for 10% off',
      };
    }
    // 2 paid — solid at 10%, soft tint toward 20%
    if (qty === 2) {
      return {
        eyebrow: '10% OFF LOCKED IN',
        title: 'One more for <em>20% off</em> <span class="cart-mobile__hero-emoji">😊</span>',
        sub: 'Add one more preset to bump your discount to 20%.',
        pill: '−10% off',
        pillGhost: false,
        fill: 33.333,
        fillSoft: 66.667,
        locked: true,
        showDot: false,
        tier: 2,
        hint: '+ Add 1 preset → 20% off',
        footerNudge: '1 more for 20% off',
      };
    }
    // 3 paid — solid at 20%, soft tint toward 30%
    if (qty === 3) {
      return {
        eyebrow: '20% OFF LOCKED IN',
        title: 'One more for <em>30% off</em> <span class="cart-mobile__hero-emoji">🤩</span>',
        sub: 'Add one preset to unlock the max bundle deal.',
        pill: '−20% off',
        pillGhost: false,
        fill: 66.667,
        fillSoft: 100,
        locked: true,
        showDot: false,
        tier: 3,
        hint: '+ Add 1 preset → 30% off',
        footerNudge: '1 more for 30% off',
      };
    }
    // 4+ — max, solid green full bar
    return {
      eyebrow: 'MAX SAVINGS UNLOCKED',
      title: 'You’re saving <em>30%</em> <span class="cart-mobile__hero-emoji">🎉</span>',
      sub: 'Max discount applied at checkout.',
      pill: '−30% off',
      pillGhost: false,
      fill: 100,
      fillSoft: 100,
      locked: true,
      showDot: false,
      tier: 4,
      hint: '✓ Max 30% off unlocked',
      footerNudge: '',
    };
  }

  /* TVB cart hero surge — particle burst from the progress bar track. */
  function fireCelebration(heroEl, kind) {
    if (!heroEl) return;
    var barTrack = heroEl.querySelector('.cart-mobile__hero-bar-track');
    var anchor = barTrack || heroEl;
    var rect = anchor.getBoundingClientRect();
    if (!rect.width) return;
    var isMax = kind === 'max';
    var count = isMax ? 20 : 14;
    var colors = isMax
      ? ['#1ea25a', '#22d97a', '#7edc3a', '#ffffff', '#86efac', '#4ade80']
      : ['#7edc3a', '#4ade80', '#34d399', '#ffffff', '#a3e635'];
    for (var i = 0; i < count; i++) {
      (function (i2) {
        var cx = rect.left + Math.random() * rect.width;
        var cy = rect.top + rect.height / 2;
        var dot = document.createElement('span');
        var sz = isMax ? 4 + Math.random() * 5 : 3 + Math.random() * 4;
        var dur = 550 + Math.random() * 350;
        var angle =
          -Math.PI * 0.9 + (i2 / count) * Math.PI * 1.8 + (Math.random() - 0.5) * 0.6;
        var dist = (isMax ? 55 : 40) + Math.random() * (isMax ? 50 : 35);
        var tx = Math.cos(angle) * dist;
        var ty = Math.sin(angle) * dist - 10;
        dot.setAttribute('aria-hidden', 'true');
        dot.style.cssText =
          'position:fixed;width:' +
          sz +
          'px;height:' +
          sz +
          'px;border-radius:50%;pointer-events:none;z-index:99999;left:' +
          cx +
          'px;top:' +
          cy +
          'px;background:' +
          colors[i2 % colors.length] +
          ';transform:translate(-50%,-50%) scale(1);opacity:1;will-change:transform,opacity;';
        document.body.appendChild(dot);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            dot.style.transition =
              'transform ' +
              dur +
              'ms cubic-bezier(0.15,0.9,0.35,1),opacity ' +
              Math.round(dur * 0.75) +
              'ms ' +
              Math.round(dur * 0.3) +
              'ms ease-out';
            dot.style.transform =
              'translate(calc(-50% + ' + tx + 'px),calc(-50% + ' + ty + 'px)) scale(0)';
            dot.style.opacity = '0';
            setTimeout(function () {
              if (dot.parentNode) dot.parentNode.removeChild(dot);
            }, dur + 60);
          });
        });
      })(i);
    }
  }

  /* kind: max (4 items / 30%) · tier (discount jump) · progress (qty up, same tier) */
  function triggerHeroSurge(kind) {
    if (!dealRoot) return;
    if (surgeTimer) clearTimeout(surgeTimer);
    dealRoot.classList.remove(
      'is-tier-activate',
      'is-max-reward',
      'is-celebrate',
      'is-progress-surge'
    );
    void dealRoot.offsetWidth;
    if (kind === 'max') {
      dealRoot.classList.add('is-max-reward');
      fireCelebration(dealRoot, 'max');
      surgeTimer = setTimeout(function () {
        dealRoot.classList.remove('is-max-reward');
      }, 1400);
    } else if (kind === 'tier') {
      dealRoot.classList.add('is-tier-activate');
      fireCelebration(dealRoot, 'tier');
      surgeTimer = setTimeout(function () {
        dealRoot.classList.remove('is-tier-activate');
      }, 1150);
    } else if (kind === 'progress') {
      dealRoot.classList.add('is-progress-surge');
      surgeTimer = setTimeout(function () {
        dealRoot.classList.remove('is-progress-surge');
      }, 800);
    }
  }

  function updateDeal(cart) {
    if (state.dealDismissed && dealRoot) {
      dealRoot.setAttribute('hidden', '');
      return;
    }
    if (dealRoot) dealRoot.removeAttribute('hidden');

    var qty = vocalPresetQty(cart);
    var copy = dealCopy(qty);

    var eyebrowLabel = root.querySelector('[data-bcaf-deal-eyebrow-label]');
    if (eyebrowLabel) eyebrowLabel.textContent = copy.eyebrow;
    else if (dealEyebrow) {
      // fallback: set text on last text node
      dealEyebrow.childNodes.forEach(function (n) {
        if (n.nodeType === 3) n.textContent = '';
      });
      dealEyebrow.appendChild(document.createTextNode(' ' + copy.eyebrow));
    }

    if (dealTitle) dealTitle.innerHTML = copy.title;
    if (dealSub) dealSub.innerHTML = copy.sub;

    // Re-query fills each paint — init-time refs can go stale after theme HMR.
    var fillEl = root.querySelector('[data-bcaf-deal-fill]');
    var fillSoftEl = root.querySelector('[data-bcaf-deal-fill-soft]');
    var solidPct = Number(copy.fill) || 0;
    var softPct = copy.fillSoft != null ? Number(copy.fillSoft) : solidPct;
    if (fillEl) {
      fillEl.style.setProperty('--mc-fill', solidPct + '%');
      fillEl.style.setProperty('width', solidPct + '%', 'important');
      fillEl.style.setProperty('display', 'block', 'important');
      fillEl.style.setProperty('opacity', '1', 'important');
      fillEl.style.setProperty(
        'background',
        copy.tier >= 4 ? '#1ea25a' : '#c2fa1a',
        'important'
      );
    }
    if (fillSoftEl) {
      /* Soft/gradient always starts at hard-fill end → next stop (recalc on qty). */
      var softStart = solidPct;
      var softSpan = Math.max(0, softPct - solidPct);
      if (copy.tier >= 4 || softSpan < 0.05) {
        fillSoftEl.setAttribute('hidden', '');
        fillSoftEl.style.setProperty('width', '0%', 'important');
        fillSoftEl.style.setProperty('left', '0%', 'important');
      } else {
        fillSoftEl.removeAttribute('hidden');
        fillSoftEl.style.setProperty('left', softStart + '%', 'important');
        fillSoftEl.style.setProperty('width', softSpan + '%', 'important');
        fillSoftEl.style.setProperty('display', 'block', 'important');
        fillSoftEl.style.setProperty('opacity', '1', 'important');
        fillSoftEl.style.setProperty(
          'background',
          'linear-gradient(90deg, #c2fa1a 0%, color-mix(in srgb, #c2fa1a 40%, #c4c9ff) 45%, #c4c9ff 100%)',
          'important'
        );
      }
    }
    if (dealPill) {
      if (copy.pill) {
        dealPill.textContent = copy.pill;
        dealPill.classList.toggle('cart-mobile__hero-pill--ghost', !!copy.pillGhost);
        dealPill.removeAttribute('hidden');
      } else {
        dealPill.textContent = '';
        dealPill.classList.remove('cart-mobile__hero-pill--ghost');
        dealPill.setAttribute('hidden', '');
      }
    }
    /* Re-query — same HMR/staleness concern as the fill bars. */
    var checkEl = root.querySelector('[data-bcaf-deal-check]') || dealCheck;
    var dotEl = root.querySelector('[data-bcaf-deal-dot]') || dealDot;
    if (checkEl) {
      var showCheck = !!copy.locked;
      checkEl.classList.toggle('is-on', showCheck);
      if (showCheck) checkEl.removeAttribute('hidden');
      else checkEl.setAttribute('hidden', '');
    }
    if (dotEl) {
      if (copy.showDot) dotEl.removeAttribute('hidden');
      else dotEl.setAttribute('hidden', '');
    }
    if (dealRoot) {
      dealRoot.classList.remove(
        'cart-mobile__hero--tier-0',
        'cart-mobile__hero--tier-1',
        'cart-mobile__hero--tier-2',
        'cart-mobile__hero--tier-3',
        'cart-mobile__hero--tier-4'
      );
      dealRoot.classList.add('cart-mobile__hero--tier-' + copy.tier);
    }
    if (upsellHint) {
      upsellHint.textContent = copy.hint;
      if (copy.tier >= 4) upsellHint.setAttribute('data-max', '1');
      else upsellHint.removeAttribute('data-max');
    }

    root.querySelectorAll('.cart-mobile__hero-bar-stop').forEach(function (stop) {
      var n = parseInt(stop.getAttribute('data-stop'), 10);
      // Stops: 1=10%@2 · 2=20%@3 · 3=30%@4+
      var wasHit = stop.classList.contains('is-hit');
      var hit =
        (n === 1 && qty >= 2) || (n === 2 && qty >= 3) || (n === 3 && qty >= 4);
      var current =
        (n === 1 && qty === 1) ||
        (n === 2 && qty === 2) ||
        (n === 3 && qty === 3);
      stop.classList.toggle('is-hit', hit);
      stop.classList.toggle('is-current', current && !hit);
      if (!wasHit && hit) {
        stop.classList.remove('is-celebrate');
        void stop.offsetWidth;
        stop.classList.add('is-celebrate');
        setTimeout(function () {
          stop.classList.remove('is-celebrate');
        }, 700);
      }
    });
    root.querySelectorAll('[data-stop-label]').forEach(function (lab) {
      var n = parseInt(lab.getAttribute('data-stop-label'), 10);
      var hit =
        (n === 1 && qty >= 2) || (n === 2 && qty >= 3) || (n === 3 && qty >= 4);
      var current =
        (n === 1 && qty === 1) ||
        (n === 2 && qty === 2) ||
        (n === 3 && qty === 3);
      lab.classList.toggle('is-hit', hit);
      lab.classList.toggle('is-current', current);
    });

    // One-shot surge when crossing discount tiers (TVB scripts.js)
    if (state.lastDealTier === null) {
      state.lastDealTier = copy.tier;
      state.lastDealQty = qty;
    } else {
      if (copy.tier === 4 && state.lastDealTier < 4) triggerHeroSurge('max');
      else if (copy.tier > state.lastDealTier) triggerHeroSurge('tier');
      else if (qty > state.lastDealQty) triggerHeroSurge('progress');
      state.lastDealTier = copy.tier;
      state.lastDealQty = qty;
    }
  }

  function paintEmptyState(cart) {
    var empty = !(cart && cart.item_count);
    root.classList.toggle('is-empty', empty);
    if (emptyEl) {
      if (empty && state.step === 4) emptyEl.removeAttribute('hidden');
      else emptyEl.setAttribute('hidden', '');
    }
    /* Always keep bag chrome (progress hero on top) visible on step 4. */
    if (mobileEl) {
      if (state.step === 4) mobileEl.removeAttribute('hidden');
      else mobileEl.setAttribute('hidden', '');
    }
    if (footerEl) {
      if (state.step === 4 && !empty) footerEl.removeAttribute('hidden');
      else footerEl.setAttribute('hidden', '');
    }
  }

  function updateFooter(cart) {
    paintEmptyState(cart);
    var count = cart.item_count || 0;
    if (countEl) countEl.textContent = String(count);
    if (bagCountEl) {
      bagCountEl.textContent = count === 1 ? '1 item' : count + ' items';
    }

    if (count < 1) {
      if (checkoutBtn) checkoutBtn.disabled = true;
      if (footerNudge) footerNudge.setAttribute('hidden', '');
      if (footerWas) footerWas.setAttribute('hidden', '');
      return;
    }

    var total = cart.total_price != null ? cart.total_price : cart.items_subtotal_price;
    var qty = vocalPresetQty(cart);
    var off = discountForQty(qty);
    var copy = dealCopy(qty);
    var displayTotal = total;
    var compareAt = 0;
    var vpIds = vpIdSet();
    var vpOriginal = 0;
    var other = 0;
    (cart.items || []).forEach(function (item) {
      var lineOrig =
        (item.original_price != null ? item.original_price : item.price) * (item.quantity || 0);
      if (vpIds[String(item.product_id)]) {
        vpOriginal += lineOrig;
      } else {
        other += item.final_line_price || 0;
      }
      compareAt += lineOrig;
    });
    // Estimate discounted total when Shopify auto-discount hasn't applied yet
    if (
      off > 0 &&
      !(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) &&
      vpOriginal > 0
    ) {
      displayTotal = Math.round(vpOriginal * (1 - off / 100)) + other;
    }

    if (footerTotal) footerTotal.textContent = formatMoney(displayTotal, true);
    if (footerWas) {
      if (compareAt > displayTotal + 1) {
        footerWas.textContent = formatMoney(compareAt, true);
        footerWas.removeAttribute('hidden');
      } else {
        footerWas.textContent = '';
        footerWas.setAttribute('hidden', '');
      }
    }

    if (footerNudge && footerNudgeLabel) {
      var nudgeText = copy.footerNudge;
      var isSaving = false;
      if (qty >= 4 && compareAt > displayTotal) {
        nudgeText = 'Saving ' + formatMoney(compareAt - displayTotal, true);
        isSaving = true;
      } else if (off > 0 && compareAt > displayTotal && !nudgeText) {
        nudgeText = 'Saving ' + formatMoney(compareAt - displayTotal, true);
        isSaving = true;
      }
      if (nudgeText) {
        footerNudgeLabel.textContent = nudgeText;
        footerNudge.classList.toggle('cart-mobile__bar-savings--nudge', !isSaving);
        footerNudge.removeAttribute('hidden');
      } else {
        footerNudgeLabel.textContent = '';
        footerNudge.setAttribute('hidden', '');
      }
    }

    if (checkoutBtn) checkoutBtn.disabled = false;
  }

  var DAW_LOGOS = {
    'fl-studio': 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-fl-studio.png?v=1785976007',
    ableton: 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-ableton.png?v=1785976007',
    'logic-pro': 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-logic-pro.png?v=1785976007',
    'pro-tools': 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-pro-tools.png?v=1785976008',
    bandlab: 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-bandlab.png?v=1785976007',
    'studio-one': 'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/daw-studio-one.png?v=1785976008',
  };

  function dawKeyFromLabel(label) {
    var s = String(label || '').toLowerCase();
    var keys = Object.keys(DAW_MATCH);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var aliases = DAW_MATCH[key] || [];
      for (var j = 0; j < aliases.length; j++) {
        if (s.indexOf(aliases[j]) !== -1) return key;
      }
    }
    return '';
  }

  function lineDawMeta(item) {
    var props = item.properties || {};
    var daw = props.DAW || props.daw || '';
    var version = props.Version || props.version || '';
    var title = String(item.variant_title || '');
    if (!daw && title && title !== 'Default Title') {
      // Variant title often "FL Studio / Waves"
      var parts = title.split(/\s*\/\s*/);
      daw = parts[0] || title;
      if (!version && parts[1]) version = parts[1];
    }
    var key = dawKeyFromLabel(daw);
    var label = daw
      ? version
        ? String(daw) + ' (' + String(version) + ')'
        : String(daw)
      : title && title !== 'Default Title'
        ? title
        : '';
    return { key: key, label: label, logo: key ? DAW_LOGOS[key] : '' };
  }

  function thumbHtml(src, alt) {
    if (!src) {
      return '<div class="cart-mobile__item-img"><span class="cart-mobile__item-img-ph" aria-hidden="true">🎁</span></div>';
    }
    var url = escapeHtml(String(src).replace(/(\.\w+)(\?|$)/, '_160x$1$2'));
    return (
      '<div class="cart-mobile__item-img">' +
      '<img src="' +
      url +
      '" alt="' +
      escapeHtml(alt || '') +
      '" width="160" height="160" loading="lazy" sizes="44px">' +
      '</div>'
    );
  }

  function giftLabelHtml() {
    return (
      '<span class="cart-mobile__item-gift-label">' +
      '<span aria-hidden="true">🎁</span> Free gift' +
      '</span>'
    );
  }

  function giftRowHtml() {
    var g = giftConfig();
    var img =
      g.image
        ? thumbHtml(g.image, g.title)
        : '<div class="cart-mobile__item-img"><span class="cart-mobile__item-img-ph" aria-hidden="true">🎁</span></div>';
    return (
      '<li class="cart-mobile__item cart-mobile__item--gift" data-bcaf-gift-row>' +
      '<div class="cart-mobile__item-card">' +
      '<button type="button" class="cart-mobile__item-close" data-bcaf-dismiss-gift aria-label="Remove gift">' +
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
      '</button>' +
      img +
      '<div class="cart-mobile__item-meta">' +
      '<div class="cart-mobile__item-name">' +
      escapeHtml(g.title) +
      '</div>' +
      giftLabelHtml() +
      '</div>' +
      '<div class="cart-mobile__item-prices">' +
      '<span class="cart-mobile__item-was">' +
      formatMoney(g.compare) +
      '</span>' +
      '<span class="cart-mobile__item-price cart-mobile__item-price--free">Free</span>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function renderBagItems(cart) {
    if (!bagItemsEl) return;
    var items = cart.items || [];
    if (!items.length) {
      bagItemsEl.innerHTML =
        '<li class="cart-mobile__cf-empty" style="list-style:none;display:block">Your bag is empty. Grab a Vocal Preset to start.</li>';
      return;
    }

    var qty = vocalPresetQty(cart);
    var off = discountForQty(qty);
    var vpIds = vpIdSet();
    var hasGiftLine = giftAlreadyInCart(cart);
    var showGiftPlaceholder = state.giftClaimed && !hasGiftLine;

    var rows = items.map(function (item) {
      var isFree = isGiftLine(item) || item.final_line_price === 0;
      var isVp = !!vpIds[String(item.product_id)];
      var original =
        (item.original_price != null ? item.original_price : item.price) * (item.quantity || 1);
      var finalPrice = item.final_line_price;
      if (!isFree && isVp && off > 0) {
        finalPrice = Math.round(original * (1 - off / 100));
      }
      // Prefer catalog compare_at so bag shows MSRP → sale like the reference.
      var cat = loadCatalog();
      var catP = null;
      var catList = cat.products || [];
      for (var ci = 0; ci < catList.length; ci++) {
        if (String(catList[ci].id) === String(item.product_id)) {
          catP = catList[ci];
          break;
        }
      }
      var compareAt =
        isFree && giftConfig().compare
          ? giftConfig().compare * (item.quantity || 1)
          : catP && catP.compare && Number(catP.compare) > Number(catP.price)
            ? Number(catP.compare) * (item.quantity || 1)
            : original;
      var showWas = !isFree && compareAt > finalPrice;
      var daw = lineDawMeta(item);
      var pluginKey = '';
      var props = item.properties || {};
      var versionRaw = props.Version || props.version || '';
      if (String(versionRaw).toLowerCase().indexOf('wave') !== -1) pluginKey = 'waves';
      else if (String(versionRaw).toLowerCase().indexOf('stock') !== -1) pluginKey = 'stock';
      else if (String(item.variant_title || '').toLowerCase().indexOf('wave') !== -1) pluginKey = 'waves';
      else if (String(item.variant_title || '').toLowerCase().indexOf('stock') !== -1) pluginKey = 'stock';

      // Always show a DAW pill for paid lines (never qty stepper).
      var baseName = (daw.key && DAW_LABELS_SHORT[daw.key]) || daw.label || 'Choose DAW';
      var dawLabel = pluginKey
        ? baseName + ' (' + (PLUGIN_LABELS[pluginKey] || pluginKey) + ')'
        : baseName;
      var dawHtml = '';
      if (!isFree) {
        dawHtml =
          '<button type="button" class="cart-mobile__item-daw-row" data-bcaf-daw-pill aria-expanded="false" aria-label="Change DAW">' +
          (daw.logo
            ? '<img class="cart-mobile__item-daw-row-logo" src="' +
              escapeHtml(daw.logo) +
              '" alt="" width="14" height="14" loading="lazy">'
            : '') +
          '<span class="cart-mobile__item-daw-row-name">' +
          escapeHtml(dawLabel) +
          '</span>' +
          '<svg class="cart-mobile__item-daw-row-caret" width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>';
      }

      return (
        '<li class="cart-mobile__item' +
        (isFree ? ' cart-mobile__item--gift' : '') +
        '" data-key="' +
        escapeHtml(item.key) +
        '" data-handle="' +
        escapeHtml(item.handle || '') +
        '" data-variant-id="' +
        escapeHtml(String(item.variant_id || '')) +
        '" data-daw="' +
        escapeHtml(daw.key || '') +
        '" data-plugin="' +
        escapeHtml(pluginKey) +
        '" data-qty="' +
        escapeHtml(String(item.quantity || 1)) +
        '">' +
        '<div class="cart-mobile__item-card">' +
        '<button type="button" class="cart-mobile__item-close" data-bcaf-remove="' +
        escapeHtml(item.key) +
        '" aria-label="Remove">' +
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
        '</button>' +
        thumbHtml(item.image, item.product_title || item.title) +
        '<div class="cart-mobile__item-meta">' +
        '<div class="cart-mobile__item-name">' +
        escapeHtml(item.product_title || item.title) +
        '</div>' +
        (isFree ? giftLabelHtml() : dawHtml) +
        '</div>' +
        '<div class="cart-mobile__item-prices">' +
        (isFree
          ? '<span class="cart-mobile__item-was">' +
            formatMoney(compareAt || original || item.price) +
            '</span>' +
            '<span class="cart-mobile__item-price cart-mobile__item-price--free">Free</span>'
          : (showWas
              ? '<span class="cart-mobile__item-was">' + formatMoney(compareAt) + '</span>'
              : '') +
            '<span class="cart-mobile__item-price">' +
            formatMoney(finalPrice) +
            '</span>') +
        '</div>' +
        '</div>' +
        (!isFree
          ? '<div class="cart-mobile__item-dropdown" data-bcaf-daw-menu hidden>' +
            '<div class="cart-mobile__item-dropdown-grid" data-bcaf-item-daw-grid></div>' +
            '</div>'
          : '') +
        '</li>'
      );
    });

    if (showGiftPlaceholder) {
      rows.unshift(giftRowHtml());
    }

    bagItemsEl.innerHTML = rows.join('');
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function linePropsHtml(item) {
    var props = item.properties || {};
    var bits = [];
    var daw = props.DAW || props.daw;
    var version = props.Version || props.version;
    if (daw && version) {
      bits.push(
        '<span class="bcaf-line__prop">' +
          escapeHtml(String(daw)) +
          ' (' +
          escapeHtml(String(version)) +
          ')</span>'
      );
    } else {
      Object.keys(props).forEach(function (k) {
        if (!k || k.charAt(0) === '_') return;
        if (props[k] == null || props[k] === '') return;
        bits.push(
          '<span class="bcaf-line__prop">' +
            escapeHtml(k) +
            ': ' +
            escapeHtml(String(props[k])) +
            '</span>'
        );
      });
      if (!bits.length && item.variant_title && item.variant_title !== 'Default Title') {
        bits.push('<span class="bcaf-line__prop">' + escapeHtml(item.variant_title) + '</span>');
      }
    }
    return bits.join('');
  }

  function renderUpsell(cart) {
    if (!upsellListEl) return;
    var cat = loadCatalog();
    var inCart = {};
    (cart.items || []).forEach(function (item) {
      inCart[String(item.product_id)] = true;
    });

    var list = (cat.products || []).filter(function (p) {
      return p && p.available !== false && !inCart[String(p.id)];
    });

    if (!list.length) {
      upsellListEl.innerHTML =
        '<p class="cart-mobile__cf-empty">All Vocal Presets are in your bag.</p>';
      return;
    }

    upsellListEl.innerHTML = list
      .slice(0, 12)
      .map(function (p) {
        return (
          '<button type="button" class="cart-mobile__cf-card" data-bcaf-upsell-add="' +
          escapeHtml(p.handle) +
          '">' +
          '<span class="cart-mobile__cf-media">' +
          (p.img
            ? '<img src="' + escapeHtml(p.img) + '" alt="" width="96" height="96" loading="lazy">'
            : '') +
          '</span>' +
          '<span class="cart-mobile__cf-name">' +
          escapeHtml(p.title) +
          '</span>' +
          '<span class="cart-mobile__cf-prices"><span class="cart-mobile__cf-price">' +
          formatMoney(p.price) +
          '</span></span>' +
          '<span class="cart-mobile__cf-add">+ Add</span>' +
          '</button>'
        );
      })
      .join('');
  }

  function bindBagBodyScroll() {
    var mobile = root.querySelector('.cart-mobile[data-bcaf-mobile]');
    var body = root.querySelector('.cart-mobile__body');
    if (!body || body.dataset.bcafScrollBound === '1') return;
    body.dataset.bcafScrollBound = '1';
    body.classList.add('bcaf-bag-scroll');

    var hideTimer = 0;
    var pullY = 0;
    var pullVel = 0;
    var sampleY = 0;
    var sampleT = 0;
    var pullRaf = 0;
    var springRaf = 0;
    var pulling = false;
    var ignorePull = false;
    var touchStartY = 0;
    var touchStartScroll = 0;
    var chrome = mobile ? mobile.querySelector('[data-bcaf-chrome]') : null;
    var hero = mobile ? mobile.querySelector('.cart-mobile__hero') : null;

    function hardMaxScroll() {
      return Math.max(0, body.scrollHeight - body.clientHeight);
    }

    /* Last real block (proof / upsell / items) — ignores checkout padding runway. */
    function contentMaxScroll() {
      var tail =
        body.querySelector('.cart-mobile__proof') ||
        body.querySelector('[data-bcaf-upsell]') ||
        body.querySelector('.cart-mobile__items');
      if (!tail) return hardMaxScroll();
      var bottom = tail.offsetTop + tail.offsetHeight;
      return Math.max(0, bottom - body.clientHeight + 8);
    }

    function clearChromeTransform() {
      /* Progress / Your bag never move with rubber-band. */
      [chrome, hero].filter(Boolean).forEach(function (el) {
        el.style.transform = '';
        el.style.willChange = '';
      });
    }

    function applyPull(y) {
      pullY = y;
      clearChromeTransform();
      /* Only the list rubber-bands — header stays stuck on top. */
      var t = Math.abs(y) < 0.25 ? '' : 'translate3d(0,' + y.toFixed(2) + 'px,0)';
      body.style.transform = t;
      body.style.willChange = t ? 'transform' : '';
    }

    /*
      iOS UIScrollView rubberBandedDistance:
        (1 - 1 / (x * 0.55 / dim + 1)) * dim
    */
    function iosRubber(offset, dimension) {
      var dim = Math.max(160, dimension || body.clientHeight || 320);
      var sign = offset < 0 ? -1 : 1;
      var x = Math.abs(offset);
      return sign * (1 - 1 / (x * 0.55 / dim + 1)) * dim;
    }

    /* UIKit-ish spring-damper with optional release velocity. */
    function springPullToZero(releaseVel) {
      if (Math.abs(pullY) < 0.25) {
        applyPull(0);
        pullVel = 0;
        return;
      }
      if (pullRaf) cancelAnimationFrame(pullRaf);
      var pos = pullY;
      var vel = typeof releaseVel === 'number' ? releaseVel : pullVel;
      pullVel = 0;
      var last = performance.now();
      var stiffness = 340;
      var damping = 2 * Math.sqrt(stiffness) * 0.9;
      function frame(now) {
        var dt = Math.min(0.032, (now - last) / 1000);
        last = now;
        var a = -stiffness * pos - damping * vel;
        vel += a * dt;
        pos += vel * dt;
        if (Math.abs(pos) < 0.15 && Math.abs(vel) < 12) {
          pullRaf = 0;
          applyPull(0);
          return;
        }
        applyPull(pos);
        pullRaf = requestAnimationFrame(frame);
      }
      pullRaf = requestAnimationFrame(frame);
    }

    function springBagScrollTo(target, onDone, releaseVel) {
      if (springRaf) cancelAnimationFrame(springRaf);
      var end = Math.max(0, Math.min(hardMaxScroll(), target));
      var pos = body.scrollTop || 0;
      var vel = typeof releaseVel === 'number' ? releaseVel : 0;
      function finish() {
        springRaf = 0;
        body.scrollTop = end;
        if (typeof onDone === 'function') onDone();
      }
      if (Math.abs(pos - end) < 0.4 && Math.abs(vel) < 8) {
        finish();
        return;
      }
      var last = performance.now();
      var stiffness = 280;
      var damping = 2 * Math.sqrt(stiffness) * 0.92;
      function frame(now) {
        var dt = Math.min(0.032, (now - last) / 1000);
        last = now;
        var x = pos - end;
        var a = -stiffness * x - damping * vel;
        vel += a * dt;
        pos += vel * dt;
        if (Math.abs(pos - end) < 0.25 && Math.abs(vel) < 14) {
          finish();
          return;
        }
        body.scrollTop = pos;
        springRaf = requestAnimationFrame(frame);
      }
      springRaf = requestAnimationFrame(frame);
    }

    function settleBagScroll() {
      pulling = false;
      ignorePull = false;
      body._bcafWheelFinger = 0;
      var y = body.scrollTop || 0;
      var cMax = contentMaxScroll();
      var hard = hardMaxScroll();

      if (Math.abs(pullY) > 0.5) springPullToZero(pullVel);

      /* Into empty bottom padding / short bag → rebound so Your bag shows. */
      if (y > cMax + 1) {
        springBagScrollTo(cMax <= 56 ? 0 : cMax);
        return;
      }
      /* Only snap short bags — use hard max so slight overflow can stay scrolled. */
      if (hard <= 56 && y > 0.5) {
        springBagScrollTo(0);
      }
    }

    function markActive() {
      if (pullRaf) {
        cancelAnimationFrame(pullRaf);
        pullRaf = 0;
      }
      if (springRaf) {
        cancelAnimationFrame(springRaf);
        springRaf = 0;
      }
    }

    body.addEventListener(
      'scroll',
      function () {
        body.classList.add('is-scrolling');
        if (hideTimer) window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(function () {
          body.classList.remove('is-scrolling');
          hideTimer = 0;
        }, 850);

        /* While finger is up, keep from parking in the padding runway. */
        if (!pulling) {
          var cMax = contentMaxScroll();
          var y = body.scrollTop || 0;
          if (y > cMax + 48) {
            if (body._bcafScrollSettle) clearTimeout(body._bcafScrollSettle);
            body._bcafScrollSettle = setTimeout(settleBagScroll, 120);
          }
        }
      },
      { passive: true }
    );

    /* Qty / checkout controls — NOT upsell cards (those need vertical bag scroll). */
    function isInteractiveTarget(t) {
      if (!t || !t.closest) return false;
      if (t.closest('.cart-mobile__cf, [data-bcaf-upsell]')) return false;
      return !!t.closest(
        'button, a, input, textarea, select, label, ' +
          '[data-bcaf-qty], [data-bcaf-remove], [data-bcaf-checkout]'
      );
    }

    function isUpsellTarget(t) {
      if (!t || !t.closest) return false;
      return !!t.closest('.cart-mobile__cf, [data-bcaf-upsell]');
    }

    function isChromeTarget(t) {
      if (!t || !t.closest) return false;
      return !!t.closest('[data-bcaf-chrome], .cart-mobile__hero, .cart-mobile__section-head');
    }

    var touchStartX = 0;
    var gestureAxis = ''; /* '', 'x', 'y' — lock for upsell carousel */
    var fromUpsell = false;

    function beginPull(clientX, clientY) {
      markActive();
      touchStartX = clientX;
      touchStartY = clientY;
      touchStartScroll = body.scrollTop || 0;
      pulling = false;
      pullVel = 0;
      sampleY = clientY;
      sampleT = performance.now();
      gestureAxis = '';
      body._bcafWheelFinger = 0;
    }

    function movePull(clientY, e) {
      var now = performance.now();
      var dt = Math.max(0.008, (now - sampleT) / 1000);
      var fingerVy = (clientY - sampleY) / dt;
      sampleY = clientY;
      sampleT = now;

      var dy = clientY - touchStartY;
      var y = body.scrollTop || 0;
      var hard = hardMaxScroll();
      var atTop = touchStartScroll <= 0 && y <= 0;
      /* Same as hear-more: only rubber at a real scroll end (hard > 0).
         cMax===0 used to mark atContentEnd always → preventDefault blocked
         native scroll in one direction. */
      var atBottom =
        hard > 0 && touchStartScroll >= hard - 1 && y >= hard - 1;
      var dim = body.clientHeight || 320;

      if (atTop && dy > 0) {
        pulling = true;
        applyPull(iosRubber(dy, dim));
        var x = Math.abs(dy);
        pullVel = fingerVy * (0.55 / Math.pow(x * 0.55 / dim + 1, 2));
        if (e && e.cancelable) e.preventDefault();
        return true;
      }
      if (atBottom && dy < 0) {
        pulling = true;
        applyPull(iosRubber(dy, dim));
        var xb = Math.abs(dy);
        pullVel = fingerVy * (0.55 / Math.pow(xb * 0.55 / dim + 1, 2));
        if (e && e.cancelable) e.preventDefault();
        return true;
      }
      if (pulling) {
        pulling = false;
        applyPull(0);
        pullVel = 0;
      }
      return false;
    }

    /* Drive bag body when vertical pan starts on the horizontal upsell strip. */
    function moveUpsellVertical(clientY, e) {
      /* Reuse rubber-band at ends; otherwise scrub scrollTop from touch delta. */
      if (movePull(clientY, e)) return;
      var dy = clientY - touchStartY;
      var hard = hardMaxScroll();
      var next = Math.max(0, Math.min(hard, touchStartScroll - dy));
      body.scrollTop = next;
      if (e && e.cancelable) e.preventDefault();
    }

    /* Mobile: one listener on the bag shell — touches on the list bubble here
       (same model as hear-more pullRoot). */
    var pullRoot = mobile || body;

    pullRoot.addEventListener(
      'touchstart',
      function (e) {
        if (!root.classList.contains('is-bag')) return;
        if (!e.touches || !e.touches[0]) return;
        /* Progress / Your bag are stuck — don't start rubber from the header. */
        if (isChromeTarget(e.target)) {
          ignorePull = true;
          fromUpsell = false;
          return;
        }
        /* Qty controls keep native behavior; upsell uses axis-lock below. */
        if (isInteractiveTarget(e.target)) {
          ignorePull = true;
          fromUpsell = false;
          return;
        }
        ignorePull = false;
        fromUpsell = isUpsellTarget(e.target);
        beginPull(e.touches[0].clientX, e.touches[0].clientY);
      },
      { passive: true }
    );

    pullRoot.addEventListener(
      'touchmove',
      function (e) {
        if (!root.classList.contains('is-bag')) return;
        if (ignorePull) return;
        if (!e.touches || !e.touches[0]) return;
        var t = e.touches[0];

        /* Upsell carousel: lock axis — vertical pans bag body, horizontal cards. */
        if (fromUpsell) {
          if (!gestureAxis) {
            var adx = Math.abs(t.clientX - touchStartX);
            var ady = Math.abs(t.clientY - touchStartY);
            if (adx < 8 && ady < 8) return;
            gestureAxis = adx > ady ? 'x' : 'y';
          }
          if (gestureAxis === 'x') return;
          moveUpsellVertical(t.clientY, e);
          return;
        }

        movePull(t.clientY, e);
      },
      { passive: false }
    );

    pullRoot.addEventListener(
      'touchend',
      function () {
        if (!root.classList.contains('is-bag')) return;
        fromUpsell = false;
        gestureAxis = '';
        settleBagScroll();
      },
      { passive: true }
    );

    pullRoot.addEventListener(
      'touchcancel',
      function () {
        if (!root.classList.contains('is-bag')) return;
        fromUpsell = false;
        gestureAxis = '';
        settleBagScroll();
      },
      { passive: true }
    );

    body.addEventListener(
      'wheel',
      function (e) {
        if (!root.classList.contains('is-bag')) return;
        markActive();
        var y = body.scrollTop || 0;
        var hard = hardMaxScroll();
        var dim = body.clientHeight || 320;
        var finger = body._bcafWheelFinger || 0;

        if (y <= 0 && e.deltaY < 0) {
          finger = Math.max(0, finger + -e.deltaY);
          body._bcafWheelFinger = finger;
          applyPull(iosRubber(finger, dim));
          pullVel = 0;
          if (e.cancelable) e.preventDefault();
          if (body._bcafWheelSettle) clearTimeout(body._bcafWheelSettle);
          body._bcafWheelSettle = setTimeout(settleBagScroll, 140);
          return;
        }
        if (hard > 0 && y >= hard - 0.5 && e.deltaY > 0) {
          finger = Math.min(0, finger - e.deltaY);
          body._bcafWheelFinger = finger;
          applyPull(iosRubber(finger, dim));
          pullVel = 0;
          if (e.cancelable) e.preventDefault();
          if (body._bcafWheelSettle) clearTimeout(body._bcafWheelSettle);
          body._bcafWheelSettle = setTimeout(settleBagScroll, 140);
          return;
        }
        if (finger !== 0 || pullY !== 0) {
          if (e.deltaY > 0 && (finger > 0 || pullY > 0)) {
            finger = Math.max(0, finger - e.deltaY);
            body._bcafWheelFinger = finger;
            applyPull(finger ? iosRubber(finger, dim) : 0);
          } else if (e.deltaY < 0 && (finger < 0 || pullY < 0)) {
            finger = Math.min(0, finger - e.deltaY);
            body._bcafWheelFinger = finger;
            applyPull(finger ? iosRubber(finger, dim) : 0);
          }
        }
      },
      { passive: false }
    );
  }

  function refreshBag() {
    bindBagBodyScroll();
    return fetchCart()
      .then(function (cart) {
        state.cart = cart;
        renderBagItems(cart);
        renderUpsell(cart);
        updateDeal(cart);
        updateFooter(cart);
        return cart;
      })
      .catch(function (err) {
        console.error('[bcaf] cart refresh failed', err);
      });
  }

  function changeQty(key, qty) {
    if (state.busy) return Promise.resolve();
    state.busy = true;
    var drawer = cartDrawer();
    var body = {
      id: key,
      quantity: Math.max(0, qty),
      sections: sectionsPayload(drawer),
      sections_url: window.location.pathname,
    };
    return fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        state.busy = false;
        applyCartSections(data);
        return refreshBag();
      })
      .catch(function (err) {
        state.busy = false;
        console.warn('[bcaf] qty change failed', err);
        return refreshBag();
      });
  }

  function open(opts) {
    opts = opts || {};
    state.handle = opts.handle || state.handle || '';
    // Keep prior DAW/plugin when reopening for upsell mid-bag (caller may set them).
    if (!opts.keepDaw) {
      state.daw = opts.daw || '';
      state.plugin = opts.plugin || '';
    }
    state.product = opts.product || null;
    state.giftClaimed = !!opts.giftClaimed;
    state.dealDismissed = false;
    state.fallbackVariantId = opts.fallbackVariantId || opts.v || null;
    if (!opts.keepDaw) resetGift();
    loadCatalog();

    if (typeof opts.count === 'number' && countEl) countEl.textContent = String(opts.count);

    ensureOpen();
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    startTimer();

    if (opts.bagOnly) {
      setStep(4);
      return;
    }

    // Always run guided flow (DAW → Waves/Stock? → gift).
    // If the chosen SKU is already in cart, finishAddFlow skips the add.
    hideAllPanels();
    if (headEl) headEl.setAttribute('hidden', '');
    if (footerEl) footerEl.setAttribute('hidden', '');
    if (steplabel) steplabel.textContent = '';
    if (steptitle) steptitle.textContent = '';
    if (stepsub) stepsub.textContent = '';

    // If product already provided and DAW known, resume after DAW
    if (state.product && state.daw && opts.resumeAfterDaw) {
      state.hasPluginChoice =
        typeof opts.hasPluginChoice === 'boolean'
          ? opts.hasPluginChoice
          : productHasPluginChoice(state.product);
      root.setAttribute('data-bcaf-has-plugin-choice', state.hasPluginChoice ? 'true' : 'false');
      syncDawButtons();
      afterDaw();
      return;
    }

    fetchCart()
      .then(function (cart) {
        if (countEl) countEl.textContent = String(cart.item_count || 0);
      })
      .catch(function () {});

    var ready = state.product
      ? Promise.resolve(state.product)
      : state.handle
        ? loadProduct(state.handle)
        : Promise.reject(new Error('missing handle'));

    ready
      .then(function (product) {
        state.product = product;
        state.hasPluginChoice =
          typeof opts.hasPluginChoice === 'boolean'
            ? opts.hasPluginChoice
            : productHasPluginChoice(product);
        root.setAttribute(
          'data-bcaf-has-plugin-choice',
          state.hasPluginChoice ? 'true' : 'false'
        );
        syncDawButtons();
        setStep(1);
      })
      .catch(function (err) {
        console.error('[bcaf] product load failed', err);
        alert('Could not load product options. Try again.');
        close();
      });
  }

  function close(fromPopstate) {
    root.classList.remove('is-open');
    state.open = false;
    document.documentElement.classList.remove('bcaf-lock', 'bcaf-blur');
    stopTimer();
    // If user closed via X / backdrop (not Back), drop the bcaf history entry
    // so the next Back does not re-open a stale state.
    try {
      if (!fromPopstate && history.state && history.state.bcaf) {
        history.replaceState(null, '', location.href);
      }
    } catch (err) {}
    setTimeout(function () {
      if (!state.open) {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
      }
    }, 320);
  }

  function resetGift() {
    if (!giftBox) return;
    giftBox.classList.remove('is-unlocked');
    if (giftArt) giftArt.classList.remove('is-revealed');
    if (giftCheck) {
      giftCheck.hidden = true;
      giftCheck.setAttribute('aria-hidden', 'true');
    }
    if (giftStatus) giftStatus.textContent = "It's a surprise — and it's on us.";
    var title = giftBox.querySelector('.cart-gift-step__title');
    if (title) title.textContent = 'A free gift is waiting';
    if (giftClaim) giftClaim.hidden = false;
    if (giftContinue) giftContinue.hidden = true;
  }

  function unlockGift() {
    if (!giftBox) return;
    state.giftClaimed = true;
    giftBox.classList.add('is-unlocked');
    if (giftArt) giftArt.classList.add('is-revealed');
    if (giftCheck) {
      giftCheck.hidden = false;
      giftCheck.setAttribute('aria-hidden', 'false');
    }
    var title = giftBox.querySelector('.cart-gift-step__title');
    if (title) title.textContent = 'Gift unlocked!';
    if (giftStatus) {
      var gift = giftConfig();
      giftStatus.textContent = gift.title + ' — free with your preset. Continue to add it.';
    }
    if (giftClaim) giftClaim.hidden = true;
    if (giftContinue) giftContinue.hidden = false;
  }

  function finishAddFlow() {
    return addSelectedVariantThenBag();
  }

  root.querySelectorAll('[data-bcaf-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      close();
    });
  });

  // Blurred left / backdrop click closes the cart (panel stays interactive).
  var backdropEl = root.querySelector('.cart-drawer__backdrop');
  if (backdropEl) {
    backdropEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      close();
    });
  }

  // Also: click any non-panel area inside the drawer root (left blur zone).
  root.addEventListener('click', function (e) {
    if (!state.open) return;
    var panel = root.querySelector('.cart-drawer__panel');
    if (panel && panel.contains(e.target)) return;
    if (e.target.closest && e.target.closest('.cart-drawer__close')) return;
    close();
  });

  root.querySelectorAll('[data-bcaf-daw]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.daw = btn.getAttribute('data-bcaf-daw') || '';
      afterDaw();
    });
  });

  root.querySelectorAll('[data-bcaf-plugin]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.plugin = btn.getAttribute('data-bcaf-plugin') || '';
      showGiftOrFinish();
    });
  });

  if (giftClaim) giftClaim.addEventListener('click', unlockGift);
  if (giftContinue) giftContinue.addEventListener('click', finishAddFlow);
  // Checkout uses official Shopify cart POST (button form="BentoCart-Form" name="checkout")
  if (emptyBrowse) {
    emptyBrowse.addEventListener('click', function (e) {
      e.preventDefault();
      close();
      var home =
        emptyBrowse.getAttribute('href') ||
        (window.Shopify && Shopify.routes && Shopify.routes.root) ||
        '/';
      window.location.assign(home);
    });
  }

  var giftSkip = root.querySelector('[data-bcaf-gift-skip]');
  if (giftSkip) {
    giftSkip.addEventListener('click', function () {
      state.giftClaimed = false;
      finishAddFlow();
    });
  }

  var dealDismiss = root.querySelector('[data-bcaf-deal-dismiss]');
  if (dealDismiss) {
    dealDismiss.addEventListener('click', function () {
      state.dealDismissed = true;
      if (dealRoot) dealRoot.setAttribute('hidden', '');
    });
  }

  function closeAllDawMenus(exceptArticle) {
    if (!bagItemsEl) return;
    bagItemsEl.querySelectorAll('.cart-mobile__item.is-dropdown-open').forEach(function (el) {
      if (exceptArticle && el === exceptArticle) return;
      el.classList.remove('is-dropdown-open');
      var pill = el.querySelector('[data-bcaf-daw-pill]');
      if (pill) pill.setAttribute('aria-expanded', 'false');
      var menu = el.querySelector('[data-bcaf-daw-menu]');
      if (menu) menu.setAttribute('hidden', '');
    });
  }

  function dawOptionCheckSvg() {
    return (
      '<svg class="cart-mobile__item-dropdown-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10" fill="#c2fa1a"/>' +
      '<path d="M7.5 12.5l3 3 6-6" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
    );
  }

  function fillDawMenu(article, product, cart) {
    var grid = article.querySelector('[data-bcaf-item-daw-grid]');
    if (!grid || !product) return;
    var lineKey = String(article.getAttribute('data-key') || '');
    var currentDaw = article.getAttribute('data-daw') || '';
    var currentPlugin = article.getAttribute('data-plugin') || '';
    var currentVid = String(article.getAttribute('data-variant-id') || '');
    var takenVids = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (String(item.key) === lineKey) return;
      takenVids[String(item.variant_id)] = true;
    });
    var keys = availableDawKeys(product);
    var options = [];

    keys.forEach(function (dawKey) {
      var plugins = pluginsForDaw(product, dawKey);
      if (!plugins.length) plugins = [''];
      plugins.forEach(function (plugin) {
        var shortName = DAW_LABELS_SHORT[dawKey] || DAW_LABELS[dawKey] || dawKey;
        var label = plugin
          ? shortName + ' (' + (PLUGIN_LABELS[plugin] || plugin) + ')'
          : shortName;
        var vid = findVariantIdFor(product, dawKey, plugin || null, null);
        if (!vid) return;
        var isCurrent =
          String(vid) === currentVid ||
          (dawKey === currentDaw && (!plugin || plugin === currentPlugin));
        options.push({
          dawKey: dawKey,
          plugin: plugin || '',
          label: label,
          vid: vid,
          isCurrent: isCurrent,
          isTaken: !isCurrent && !!takenVids[String(vid)],
        });
      });
    });

    if (!options.length) {
      grid.innerHTML =
        '<p style="grid-column:1/-1;margin:0;color:#6b7280;font-size:0.8rem;">No DAW options for this preset.</p>';
      return;
    }

    grid.innerHTML = options
      .map(function (opt) {
        return (
          '<button type="button" class="cart-mobile__item-dropdown-btn' +
          (opt.isCurrent ? ' is-current' : '') +
          (opt.isTaken ? ' is-taken' : '') +
          '" data-bcaf-daw-option data-daw="' +
          escapeHtml(opt.dawKey) +
          '" data-plugin="' +
          escapeHtml(opt.plugin) +
          '" data-variant-id="' +
          escapeHtml(String(opt.vid)) +
          '"' +
          (opt.isTaken ? ' data-taken="1" aria-disabled="true" title="Already in your bag"' : '') +
          '>' +
          (DAW_LOGOS[opt.dawKey]
            ? '<img src="' +
              escapeHtml(DAW_LOGOS[opt.dawKey]) +
              '" alt="" width="24" height="24" loading="lazy">'
            : '') +
          '<span>' +
          escapeHtml(opt.label) +
          '</span>' +
          (opt.isCurrent ? dawOptionCheckSvg() : '') +
          '</button>'
        );
      })
      .join('');
  }

  function openDawMenu(article) {
    closeAllDawMenus(article);
    var handle = article.getAttribute('data-handle');
    var menu = article.querySelector('[data-bcaf-daw-menu]');
    var pill = article.querySelector('[data-bcaf-daw-pill]');
    if (!handle || !menu) return;

    article.classList.add('is-dropdown-open');
    menu.removeAttribute('hidden');
    if (pill) pill.setAttribute('aria-expanded', 'true');

    var grid = article.querySelector('[data-bcaf-item-daw-grid]');
    if (grid) {
      grid.innerHTML =
        '<p style="grid-column:1/-1;margin:0;color:#6b7280;font-size:0.8rem;">Loading…</p>';
    }

    var productReady = article._bcafProduct
      ? Promise.resolve(article._bcafProduct)
      : loadProduct(handle);

    Promise.all([productReady, fetchCart()])
      .then(function (pair) {
        var product = pair[0];
        var cart = pair[1];
        article._bcafProduct = product;
        fillDawMenu(article, product, cart);
      })
      .catch(function (err) {
        console.error('[bcaf] daw menu load failed', err);
        if (grid) {
          grid.innerHTML =
            '<p style="grid-column:1/-1;margin:0;color:#e11d48;font-size:0.8rem;">Could not load DAW options.</p>';
        }
      });
  }

  function swapLineDaw(article, dawKey, pluginKey, variantId) {
    var lineKey = article.getAttribute('data-key');
    var qty = parseInt(article.getAttribute('data-qty'), 10) || 1;
    var product = article._bcafProduct;
    var id = Number(variantId) || findVariantIdFor(product, dawKey, pluginKey, null);
    if (!lineKey || !id) {
      closeAllDawMenus();
      return;
    }
    if (String(id) === String(article.getAttribute('data-variant-id'))) {
      closeAllDawMenus();
      return;
    }

    var properties = {};
    if (dawKey) properties.DAW = dawLabelForKey(dawKey);
    if (pluginKey) properties.Version = pluginLabelForKey(pluginKey);

    article.querySelectorAll('[data-bcaf-daw-option]').forEach(function (b) {
      b.classList.add('is-loading');
    });

    function clearLoading() {
      if (!article.isConnected) return;
      article.querySelectorAll('[data-bcaf-daw-option]').forEach(function (b) {
        b.classList.remove('is-loading');
      });
    }

    function otherLineHasVariant(cart, variantId) {
      return ((cart && cart.items) || []).some(function (item) {
        return String(item.variant_id) === String(variantId) && String(item.key) !== String(lineKey);
      });
    }

    // Same preset already has this variant on another line → block swap,
    // close the menu, keep both lines as they are (no remove, no alert).
    fetchCart()
      .then(function (cart) {
        if (otherLineHasVariant(cart, id)) {
          closeAllDawMenus();
          clearLoading();
          return null;
        }
        // Normal swap: add target, then remove the old line
        return addByVariant(id, properties, qty)
          .then(function (data) {
            if (!data) {
              return fetchCart().then(function (c2) {
                if (otherLineHasVariant(c2, id)) {
                  closeAllDawMenus();
                  return null;
                }
                if (variantAlreadyInCart(c2, id)) return changeQty(lineKey, 0);
                return null;
              });
            }
            return changeQty(lineKey, 0);
          })
          .then(function () {
            closeAllDawMenus();
            return refreshBag();
          })
          .catch(function (err) {
            console.warn('[bcaf] daw swap skipped', err);
            closeAllDawMenus();
            return refreshBag();
          });
      })
      .catch(function (err) {
        console.warn('[bcaf] daw swap skipped', err);
        closeAllDawMenus();
        return refreshBag();
      })
      .finally(clearLoading);
  }

  if (bagItemsEl) {
    bagItemsEl.addEventListener('click', function (e) {
      var dismissGift = e.target.closest('[data-bcaf-dismiss-gift]');
      if (dismissGift) {
        e.preventDefault();
        state.giftClaimed = false;
        return refreshBag();
      }

      var removeBtn = e.target.closest('[data-bcaf-remove]');
      if (removeBtn) {
        var giftItem = removeBtn.closest('.cart-mobile__item--gift');
        if (giftItem) state.giftClaimed = false;
        changeQty(removeBtn.getAttribute('data-bcaf-remove'), 0);
        return;
      }

      var optionBtn = e.target.closest('[data-bcaf-daw-option]');
      if (optionBtn) {
        e.preventDefault();
        e.stopPropagation();
        var artOpt = optionBtn.closest('.cart-mobile__item');
        if (!artOpt) return;
        // Already on another line — close menu, keep both lines
        if (optionBtn.getAttribute('data-taken') === '1' || optionBtn.classList.contains('is-taken')) {
          closeAllDawMenus();
          return;
        }
        swapLineDaw(
          artOpt,
          optionBtn.getAttribute('data-daw') || '',
          optionBtn.getAttribute('data-plugin') || '',
          optionBtn.getAttribute('data-variant-id') || ''
        );
        return;
      }

      var pill = e.target.closest('[data-bcaf-daw-pill]');
      if (pill) {
        e.preventDefault();
        e.stopPropagation();
        var art = pill.closest('.cart-mobile__item');
        if (!art) return;
        if (art.classList.contains('is-dropdown-open')) {
          closeAllDawMenus();
        } else {
          openDawMenu(art);
        }
        return;
      }
    });
  }

  // Click outside bag items closes open DAW menus
  document.addEventListener('click', function (e) {
    if (!bagItemsEl || !state.open) return;
    if (e.target.closest('[data-bcaf-bag-items]')) return;
    closeAllDawMenus();
  });

  if (upsellListEl) {
    upsellListEl.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bcaf-upsell-add]');
      if (!card || state.busy) return;
      var handle = card.getAttribute('data-bcaf-upsell-add');
      if (!handle) return;

      // Already picked DAW this session → add with same options and stay on bag.
      if (state.daw) {
        var savedDaw = state.daw;
        var savedPlugin = state.plugin;
        loadProduct(handle)
          .then(function (product) {
            state.handle = handle;
            state.product = product;
            state.hasPluginChoice = productHasPluginChoice(product);
            state.daw = savedDaw;
            state.plugin = savedPlugin;
            var plugins = pluginsForDaw(product, state.daw);
            if (state.hasPluginChoice && plugins.length > 1) {
              if (!state.plugin || plugins.indexOf(state.plugin) === -1) {
                // Need Waves/Stock for this product — guided step, then bag again.
                open({
                  handle: handle,
                  product: product,
                  hasPluginChoice: true,
                  keepDaw: true,
                  resumeAfterDaw: true,
                });
                return null;
              }
            } else {
              state.plugin = plugins[0] || '';
            }
            ensureOpen();
            return addSelectedVariantThenBag();
          })
          .catch(function (err) {
            console.error('[bcaf] upsell add failed', err);
            open({ handle: handle });
          });
        return;
      }

      // No DAW yet — guided flow, then bag stays open after add.
      open({ handle: handle });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  function attachApi() {
    var existing = window.CartDrawer;
    var api = {
      addFlow: function (handle, opts) {
        var o = Object.assign({}, opts || {});
        if (typeof handle === 'string') o.handle = handle;
        else if (handle && typeof handle === 'object') o = Object.assign(o, handle);
        open(o);
      },
      openAddFlow: function (opts) {
        open(opts || {});
      },
      openBag: function () {
        open({ bagOnly: true });
      },
      closeAddFlow: close,
      refreshBag: refreshBag,
    };

    if (typeof existing === 'function') {
      existing.addFlow = api.addFlow;
      existing.openAddFlow = api.openAddFlow;
      existing.openBag = api.openBag;
      existing.closeAddFlow = api.closeAddFlow;
      existing.refreshBag = api.refreshBag;
    } else {
      window.CartDrawer = Object.assign(existing || {}, api);
    }

    window.BentoCartAddFlow = api;
  }

  attachApi();
  document.addEventListener('DOMContentLoaded', attachApi);
  window.addEventListener('load', attachApi);

  // Cart icon → always open bcaf bag (Dawn drawer removed)
  function bindCartIcon() {
    var link = document.querySelector('#cart-icon-bubble');
    if (!link || link.dataset.bcafBound === '1') return;
    link.dataset.bcafBound = '1';
    link.setAttribute('role', 'button');
    // Avoid navigating to native /cart if JS is slow or preventDefault is skipped.
    if (link.tagName === 'A') {
      link.setAttribute('href', '#');
    }
    link.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        open({ bagOnly: true });
      },
      true
    );
  }
  bindCartIcon();
  document.addEventListener('DOMContentLoaded', bindCartIcon);
  window.addEventListener('load', bindCartIcon);

  // Mobile Back while drawer is open → close drawer, stay on current page.
  window.addEventListener('popstate', function () {
    if (state.open) close(true);
  });

  // Native /cart page → bounce into guided bag on the storefront home.
  try {
    var path = location.pathname || '';
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cartPath = (rootPath.replace(/\/?$/, '/') + 'cart').replace(/\/+/g, '/');
    if (path === '/cart' || path === cartPath || /\/cart\/?$/.test(path)) {
      var home = rootPath.indexOf('http') === 0 ? rootPath : rootPath || '/';
      if (home.slice(-1) !== '/' && home !== '/') home += '/';
      location.replace(home + (home.indexOf('?') >= 0 ? '&' : '?') + 'bcaf=bag');
    }
  } catch (e) {}

  try {
    if (/[?&]bcaf=1(?:&|$)/.test(location.search)) {
      document.addEventListener('DOMContentLoaded', function () {
        open({ handle: 'the-blueprint-preset', count: 0 });
      });
    }
    if (/[?&]bcaf=bag(?:&|$)/.test(location.search)) {
      document.addEventListener('DOMContentLoaded', function () {
        open({ bagOnly: true });
      });
    }
  } catch (e) {}
})();
